import React, { useMemo, useState } from "react";
import SectionHeader from "../components/SectionHeader";
import ProductCard from "../components/ProductCard";
import ReviewCard from "../components/ReviewCard";

import heroImg from "../assets/hero.svg";
import aboutImg from "../assets/about.svg";
import contactImg from "../assets/contact.svg";

import p1 from "../assets/product-1.svg";
import p2 from "../assets/product-2.svg";
import p3 from "../assets/product-3.svg";
import p4 from "../assets/product-4.svg";
import p5 from "../assets/product-5.svg";
import p6 from "../assets/product-6.svg";

import a1 from "../assets/avatar-1.svg";
import a2 from "../assets/avatar-2.svg";
import a3 from "../assets/avatar-3.svg";
import a4 from "../assets/avatar-4.svg";
import a5 from "../assets/avatar-5.svg";

export default function Home() {
  const products = [
    { image: p1, name: "Citrus Zest Candle", subtitle: "Orange peel • Neroli • Vanilla", tags: ["Fresh", "Soy Wax", "Gift"], price: "₹799" },
    { image: p2, name: "Monsoon Mist Diffuser", subtitle: "Petrichor • Vetiver • Cedar", tags: ["Relaxing", "Long-lasting"], price: "₹1,199" },
    { image: p3, name: "Spice Market Oil", subtitle: "Cinnamon • Clove • Amber", tags: ["Warm", "Festive"], price: "₹999" },
    { image: p4, name: "Lavender Calm Candle", subtitle: "Lavender • Chamomile • Musk", tags: ["Sleep", "Soft"], price: "₹849" },
    { image: p5, name: "Rose Garden Room Spray", subtitle: "Rose • Peony • Fresh green", tags: ["Floral", "Instant"], price: "₹699" },
    { image: p6, name: "Tea & Bergamot Diffuser", subtitle: "Green tea • Bergamot • Sandal", tags: ["Elegant", "Studio"], price: "₹1,299" },
  ];

  const reviews = [
    { avatar: a1, name: "Aarav Mehta", role: "Cafe Owner, Pune", rating: 5, quote: "Our customers keep asking what smells so good. The diffuser is subtle and premium." },
    { avatar: a2, name: "Nandini Rao", role: "Interior Stylist, Bengaluru", rating: 5, quote: "The candles elevate every space. Clean burn and the fragrance throw is excellent." },
    { avatar: a3, name: "Kabir Singh", role: "Founder, D2C Brand", rating: 4, quote: "Packaging is beautiful and delivery was quick. Great gifting option for clients." },
    { avatar: a4, name: "Meera Iyer", role: "Yoga Studio, Chennai", rating: 5, quote: "Lavender Calm is a must. It sets the tone for our evening sessions perfectly." },
    { avatar: a5, name: "Rohan Kulkarni", role: "Corporate Admin, Mumbai", rating: 4, quote: "We ordered for office hampers. The team loved the fragrance and presentation." },
  ];

  const business = useMemo(() => ({
    name: "Seasons Flavours & Fragrances",
    email: "admin@seasonsflavoursfragrance.shop",
    address: "ground 30, g, Nayandahalli Pantharapalaya, Mysore Road, Bengaluru, Bangluru (Bangalore) Urban, Karnatka 560039"
    
  }), []);

  const [form, setForm] = useState({ fullName: "", email: "", phone: "", message: "" });
  const [status, setStatus] = useState(null);

  function update(key, value){
    setForm((p) => ({ ...p, [key]: value }));
  }

  function onSubmit(e){
    e.preventDefault();
    setStatus({
      type: "success",
      text: "Thanks! Your message has been captured (demo). Connect this form to EmailJS / Formspree / your backend later."
    });
    setForm({ fullName: "", email: "", phone: "", message: "" });
  }

  return (
    <>
      {/* HERO */}
      <section className="hero sectionPadTop">
        <div className="container heroGrid">
          <div>
            <div className="badge">🍃 Small-batch • Seasonal • Handcrafted</div>
            <h1 className="heroTitle">
              Flavours & fragrances that feel like a season.
            </h1>
            <p className="heroLead">
              Seasons Flavours Fragrance creates thoughtfully crafted candles, diffusers and aroma blends —
              designed to make homes, cafes and workspaces feel fresh, warm and welcoming.
            </p>
            <div className="heroBtns">
              <a className="btn primary" href="#products">Explore Products</a>
              <a className="btn accent" href="#contact">Bulk / Corporate Orders</a>
            </div>

            <div className="heroStats">
              <div className="stat card">
                <div className="statNum">30+</div>
                <div className="small">Seasonal blends</div>
              </div>
              <div className="stat card">
                <div className="statNum">4.8/5</div>
                <div className="small">Avg. client rating</div>
              </div>
              <div className="stat card">
                <div className="statNum">2–5 days</div>
                <div className="small">Pan-India delivery</div>
              </div>
            </div>
          </div>

          <div className="heroArt card">
            <img src={heroImg} alt="Seasonal fragrance illustration" className="heroImg" />
            <div className="heroArtNote">
              <div className="pill">New</div>
              <div>
                <div className="heroArtTitle">Spring Collection</div>
                <div className="small">Peony • Citrus • Green Tea</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ABOUT */}
      <section className="section" id="about">
        <div className="container aboutGrid">
          <div>
            <SectionHeader
              kicker="About Us"
              title="A brand built on seasons, memories, and warmth"
              lead="We started Seasons Flavours Fragrance with one simple idea: the right aroma can change the mood of a room — and the mood of a day."
            />
            <div className="card aboutCard">
              <p className="aboutP">
                Every product is made in small batches using clean-burning wax, high-quality fragrance oils,
                and thoughtful packaging. Our blends are inspired by Indian seasons — spring florals, monsoon
                freshness, winter spice, and summer citrus.
              </p>
              <div className="hr" />
              <div className="aboutHighlights">
                <div className="highlight">
                  <div className="highlightTitle">Clean & safe</div>
                  <div className="small">Phthalate-free fragrance oils and tested wicks for a consistent burn.</div>
                </div>
                <div className="highlight">
                  <div className="highlightTitle">Made for gifting</div>
                  <div className="small">Premium packaging and custom labels for events and corporate gifting.</div>
                </div>
                <div className="highlight">
                  <div className="highlightTitle">Seasonal drops</div>
                  <div className="small">New collections every season so your space always feels fresh.</div>
                </div>
              </div>
            </div>
          </div>

          <div className="card aboutArt">
            <img src={aboutImg} alt="About illustration" className="aboutImg" />
            <div className="aboutArtLabel">
              <span className="pill">Our Promise</span>
              <div className="small">Thoughtful craft • Reliable quality • Warm service</div>
            </div>
          </div>
        </div>
      </section>

      {/* PRODUCTS */}
      <section className="section" id="products">
        <div className="container">
          <SectionHeader
            kicker="Products"
            title="A collection crafted to match your mood"
            lead="Pick a fragrance for your season. All products shown here are dummy items for the demo website."
          />
          <div className="grid productsGrid">
            {products.map((p) => <ProductCard key={p.name} {...p} />)}
          </div>

          <div className="card callout" style={{ marginTop: 22 }}>
            <div className="calloutInner">
              <div>
                <div className="calloutTitle">Need corporate gifting?</div>
                <div className="small">We can do custom labels + bulk pricing + gift-ready boxes.</div>
              </div>
              <a className="btn primary" href="#contact">Contact us</a>
            </div>
          </div>
        </div>
      </section>

      {/* REVIEWS */}
      <section className="section" id="reviews">
        <div className="container">
          <SectionHeader
            kicker="Clients Reviews"
            title="Loved by homes & businesses"
            lead="These are dummy reviews for the website sample — you can easily replace them with real testimonials later."
          />
          <div className="grid reviewsGrid">
            {reviews.map((r) => <ReviewCard key={r.name} {...r} />)}
          </div>
        </div>
      </section>

      {/* CONTACT */}
      <section className="section" id="contact">
        <div className="container contactGrid">
          <div>
            <SectionHeader
              kicker="Contact Us"
              title="Let’s create your perfect ambience"
              lead="Send us a message for bulk orders, corporate gifting, custom labels, or product queries."
            />

            <div className="card contactCard">
              <form onSubmit={onSubmit} className="form">
                <div className="formRow">
                  <div>
                    <label className="label">Full Name</label>
                    <input
                      className="input"
                      value={form.fullName}
                      onChange={(e) => update("fullName", e.target.value)}
                      placeholder="Your name"
                      required
                    />
                  </div>
                  <div>
                    <label className="label">Email</label>
                    <input
                      className="input"
                      value={form.email}
                      onChange={(e) => update("email", e.target.value)}
                      placeholder="you@example.com"
                      type="email"
                      required
                    />
                  </div>
                </div>

                <div className="formRow">
                  <div>
                    <label className="label">Phone</label>
                    <input
                      className="input"
                      value={form.phone}
                      onChange={(e) => update("phone", e.target.value)}
                      placeholder="+91 XXXXX XXXXX"
                      required
                    />
                  </div>
                  <div className="small">
                    <div className="label">Business Info</div>
                    <div className="bizInfo">
                      <div><b>Name:</b> {business.name}</div>
                      <div><b>Email:</b> {business.email}</div>
                      <div><b>Address:</b> {business.address}</div>
                    </div>
                  </div>
                </div>

                <div>
                  <label className="label">Message</label>
                  <textarea
                    className="textarea"
                    value={form.message}
                    onChange={(e) => update("message", e.target.value)}
                    placeholder="Tell us what you need…"
                    required
                  />
                </div>

                <div className="formActions">
                  <button className="btn primary" type="submit">Send Message</button>
                  {status ? <div className={`status ${status.type}`}>{status.text}</div> : null}
                </div>
              </form>
            </div>
          </div>

          <div className="card contactArt">
            <img src={contactImg} alt="Contact illustration" className="contactImg" />
            <div className="contactTips">
              <div className="pill">Quick tips</div>
              <ul className="tipsList">
                <li>Bulk orders: share quantity + delivery city.</li>
                <li>Corporate gifting: share budget per box.</li>
                <li>Custom labels: share logo + event date.</li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
